export default __webpack_public_path__ + "static/media/MDX.7ded1798.png";